var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import Http from '../../../../app/http';
import { buildShopUsersColumns } from './columns';
import { ShopUsersList } from './shop-users-list';
import { mapBarbersToUserListEntries, mapShopUsersToUserListEntries, } from './utils';
export var UsersList = function (props) {
    var shop = props.parentRow.original;
    var shopWithUsersQuery = useQuery(['admin', 'shopUsers', shop.id], function () {
        return Http.get("/shop/".concat(shop.id), { include: 'users.brands' });
    });
    var shopsBarbersQuery = useQuery(['admin', 'shopBarbersWithUsers', shop.id], function () {
        return Http.get("/shop/".concat(shop.id, "/barber"), { include: 'users' });
    });
    var columns = useMemo(function () { return buildShopUsersColumns(shop); }, []);
    var data = useMemo(function () {
        var shopWithUsers = shopWithUsersQuery.data;
        var shopListEntries = shopWithUsers ? mapShopUsersToUserListEntries(shopWithUsers.users, shop) : [];
        var barbers = shopsBarbersQuery.data || [];
        return __spreadArray(__spreadArray([], shopListEntries, true), mapBarbersToUserListEntries(barbers), true);
    }, [shopWithUsersQuery.data, shopsBarbersQuery.data]);
    var table = useReactTable({
        data: data,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
    });
    return _jsx(ShopUsersList, { table: table, loading: shopWithUsersQuery.isLoading || shopsBarbersQuery.isLoading });
};
